import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseAdvertismentGroup() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      id: isEmpty(state.id),
    };

    setter(errorState);

    if (errorState.title || errorState.id) {
      enqueueSnackbar("لطفا عنوان گروه را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getGroupList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_AdvertismentGroups?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllGroupList = (callback) => {
    MyAxios.get(`Admin_AdvertismentGroups?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getGroupByID = (id, callback) => {
    MyAxios.get(`Admin_AdvertismentGroups/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_AdvertismentGroups`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_AdvertismentGroups`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteGroup = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_AdvertismentGroups`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getGroupList,
    getAllGroupList,
    getGroupByID,
    validate,
    updateGroup,
    addGroup,
    deleteGroup,
  };
}
